import React from 'react';
import SignupForm from '../components/auth/SignupForm';

export default function Signup() {
  return <SignupForm role="user" />;
}
